import { useApolloClient } from '@apollo/client/react'
import { Region as AwsRegion } from '@faceup/utils'
import { graphql } from '../__generated__'

const query = {
  ReportPasswordDiscovery: graphql(`
    query ReportPasswordDiscoveryQuery($password: GraphQLString!) {
      reportPasswordDiscovery(password: $password) {
        regionId
        institutionId
        reportSourceId
        type
      }
    }
  `),
  ShortlinkDiscovery: graphql(`
    query ShortlinkDiscoveryQuery($shortlink: GraphQLString!) {
      shortlinkDiscovery(shortlink: $shortlink) {
        regionId
        institutionId
        reportSourceId
        type
      }
    }
  `),
  TokenDiscovery: graphql(`
    query TokenDiscoveryQuery($token: GraphQLString!) {
      region: tokenDiscovery(token: $token)
    }
  `),
}

export let region: AwsRegion = AwsRegion.EuWest1

// Discovery runs during render through usePromiseSuspense, where Apollo 4 forbids a lazy query
export const useRegion = () => {
  const client = useApolloClient()

  const discoverByToken = async (token: string) => {
    const { data } = await client.query({
      query: query.TokenDiscovery,
      variables: { token },
      fetchPolicy: 'network-only',
    })

    if (!data?.region) {
      return null
    }
    region = data.region as AwsRegion

    return data.region as AwsRegion
  }

  const discoverByReportPassword = async (password: string) => {
    const { data } = await client.query({
      query: query.ReportPasswordDiscovery,
      variables: { password },
      fetchPolicy: 'network-only',
    })

    if (!data?.reportPasswordDiscovery?.regionId) {
      return null
    }
    region = data?.reportPasswordDiscovery?.regionId as AwsRegion

    return data.reportPasswordDiscovery
  }

  const discoverByShortlink = async (shortlink: string) => {
    const { data } = await client.query({
      query: query.ShortlinkDiscovery,
      variables: { shortlink },
      fetchPolicy: 'network-only',
    })

    if (!data?.shortlinkDiscovery?.regionId) {
      return null
    }

    region = data?.shortlinkDiscovery?.regionId as AwsRegion

    return data.shortlinkDiscovery
  }

  return {
    discoverByReportPassword,
    discoverByShortlink,
    discoverByToken,
  }
}
